import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum MessageDirection {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum MarketingMessageType {
  INITIAL = "INITIAL",
  REPLY = "REPLY",
}

export const baseMarketingMessageSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  conversationId: zExt.objectId(),
  direction: createEnum(MessageDirection),
  type: createEnum(MarketingMessageType),
  to: z.string(),
  from: z.string(),
  llmThreadId: zExt.objectId().nullish(),
  idempotencyKey: z.string().optional(), // Webhook unique ID for inbound messages only
  draftedAt: z.date().nullish(),
  scheduledAt: z.date().nullish(),
  sentAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  failedAt: z.date().nullish(),
});
export const baseMarketingMessageSchema: z.ZodType<BaseMarketingMessage> =
  baseMarketingMessageSchema_;
export interface BaseMarketingMessage
  extends z.infer<typeof baseMarketingMessageSchema_> {}

const marketingMessageAttachmentSchema = z.object({
  url: z.string(),
  contentType: z.string().optional(),
});

const smsMarketingMessageSchema_ = baseMarketingMessageSchema_.extend({
  channel: z.literal(MarketingChannel.SMS),
  content: z.string(),
  attachments: z.array(marketingMessageAttachmentSchema).optional(),
});
export const smsMarketingMessageSchema: z.ZodType<SmsMarketingMessage> =
  smsMarketingMessageSchema_;
export interface SmsMarketingMessage
  extends z.infer<typeof smsMarketingMessageSchema_> {}

const emailMarketingMessageSchema_ = baseMarketingMessageSchema_.extend({
  channel: z.literal(MarketingChannel.EMAIL),
  emailTemplate: emailTemplateSchema,
});
export const emailMarketingMessageSchema: z.ZodType<EmailMarketingMessage> =
  emailMarketingMessageSchema_;
export interface EmailMarketingMessage
  extends z.infer<typeof emailMarketingMessageSchema_> {}

const marketingMessageSchema_ = z.discriminatedUnion("channel", [
  smsMarketingMessageSchema_,
  emailMarketingMessageSchema_,
]);
export const marketingMessageSchema: z.ZodType<MarketingMessage> =
  marketingMessageSchema_;
export type MarketingMessage = SmsMarketingMessage | EmailMarketingMessage;
